module.exports = __webpack_public_path__ + "static/media/bg4.d874bfb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg4.jpg
// module id = 586
// module chunks = 0